export const workspace = {
  routes: [
    {
      path: "/workspace/library/domestic-third-party",
      component: () => import("../workspace-library-domestic-third-party-view"),
    },
  ],
};

export const management = {
  routes: [
    {
      path: "/management/domestic-third-party",
      component: () => import("../management-library-domestic-third-party-view"),
    },
  ],
};
